import { useEventStore } from '../../store/event/eventStore';

/**
 * Get difference in time between now and the first event. Number returned is always positive
 */
export const useEventStart = () => {
  let futureEvents = useEventStore((s) => s.events)?.filter((event) => event.eventStartTime > Date.now());
  let minTime = 0;
  if (futureEvents) {
    futureEvents = futureEvents.filter((event) => event.eventStartTime > Date.now());
    futureEvents.sort((a, b) => a.eventStartTime - b.eventStartTime);
    minTime = futureEvents?.[0]?.eventStartTime;
  }

  const timeTillStart = (minTime ?? 0) - Date.now();
  return timeTillStart < 0 ? 0 : timeTillStart;
};
